import {
    ADDITIONAL_REQUIRMENT,
    LOCAL_BENEFIT,
    REQUISITION_LIST,
    REQUISITION_ITEM,
    UNAUTHORIZE,
    LOADING,
    JOB_DESCRIPTION,
    JOB_REQUIRMENT,
    FORM_RESET,
    LOAD_BENEFIT
} from './ActionType'
import {
    stateToHTML
} from 'draft-js-export-html'
import axios from 'axios'
import {
    END_POINT_REQUISITION,
    END_POINT_GET_REQUISITIONS,
    END_POINT_APPROVE_REQUISITIONS
} from '../api/EndPoint'
import {
    GET_SUCCESS,
    RESPONSE_CODE_UNAUTHORIZED,
    INSERT_SUCCESS
} from '../api/ResponseType'
import {
    JWT,
    FORM_REQUISITION
} from '../utils/CommonConstant'
import {
    reset
} from 'redux-form'
import moment from 'moment'


export const submitRequisition = (data) => dispatch => {

    const {
        source,
        channel_1,
        channel_2,
        process,
        length,
        industry,
        international,
        others_benefits,
        interviewer1,
        interviewer2,
        interviewer3,
        interviewer4,
        interviewer5,
    } = data.form.requisition.values

    const advertising_channel =[]

    if(channel_1){
        advertising_channel.push("jobnet")
    }

    if(channel_2) {
        advertising_channel.push("linkedin")
    }

    const {
        employee_name,
        number_of_positions,
        target_date,
        type
    } = data.form.JobInformation.values

    const {
        contract,
        currency_type,
        department,
        designation,
        start_date,
        end_date,
        entity,
        department_head_email,
        hiring_manager_email,
        location,
        max_salary,
        min_salary,
        position_title,
        confidential
    } = data.form.PositionInformation.values

    const {
        category,
        benefits,
        job_description,
        job_requirment,
    } = data.requisition

    if( others_benefits !== undefined){
        benefits.push(others_benefits)
    }

    const request ={
        msg: "message",
        status: "pending",
        submitted_by: "test",
        type: type === "1" ? "new":"replacement",
        replacement : {
            employee_name,
        },
        number_of_positions,
        target_date: target_date === undefined ? "" : target_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
        position_information: {
            title: position_title,
            designation,
            contract:{
                type: contract,
                from: start_date === undefined ? moment().format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : start_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]"),
                to: end_date === undefined ? moment().format("ddd, DD MMM YYYY HH:mm:ss [GMT]") : end_date.format("ddd, DD MMM YYYY HH:mm:ss [GMT]")
            },
            salary:{
                min: {
                    amount: min_salary,
                    type: currency_type
                },
                max: {
                    amount: max_salary,
                    type: currency_type
                }
            },
            entity,
            department,
            location,
            description: job_description,
            requirements: job_requirment,
            category
        },
        sourcing: {
            advertising: { 
                channels: advertising_channel,
                industry,
                international: international === 'yes' ? true: false,
                length,
                process,
                confidential: confidential === "1" ? true : false,
                comments:"",
                source
            }
        },
        additional_information: {
            benefits
        },
        interviewers: [interviewer1, interviewer2, interviewer3, interviewer4, interviewer5],
        hiring_manager_email,
        department_head_email
    }

    dispatch({
        type: LOADING,
        payload: true
    })

    axios(
        {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': true,
            'Authorization': "Bearer jhhmh",//sessionStorage.getItem(JWT),
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_REQUISITION,
            data: request
        }
    ).then( response => {

        dispatch({
            type: LOADING,
            payload: false
        })

        if(response.status === INSERT_SUCCESS){

            dispatch(reset(FORM_REQUISITION)) // clear form data
            dispatch(reset("JobInformation"))
            dispatch(reset("PositionInformation"))
            dispatch({
                type: FORM_RESET
            })
            window.alert("Successfully Created")
        }else{
            window.alert("Failed")
        }

    }).catch( error => {

        dispatch({
            type: LOADING,
            payload: false
        })

        window.alert("Error! "+error)

    })

}

export const getRequisitionList = (page_index, jwt) => dispatch => {

    axios(
        {
            method: 'get',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem(JWT) === null ? jwt:sessionStorage.getItem(JWT),
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
            },
            withCredentials: false,
            mode: 'no-cors',
            url: END_POINT_GET_REQUISITIONS,
            params: { page: page_index, sort: "-_created"}
        }
    ).then( response => {

        if(response.status === GET_SUCCESS){
            dispatch({
                type: UNAUTHORIZE,
                payload: false
            })
            dispatch({
                type: REQUISITION_LIST,
                payload: response.data._items
            })
        }else{
            window.alert("RESPONSE ERROR!")
        }

    }).catch( error => {

        if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
            dispatch({
                type: UNAUTHORIZE,
                payload: true
            })
        }else{
            window.alert(error)
        }
        
    })

}

export const updateRequisitionStatus = (prop) => dispatch => {

    const {item, status, page_index} = prop

    axios(
        {
            method: 'post',
            headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionStorage.getItem(JWT),
            'pragma': 'no-cache',
            'cache-control': 'no-cache'
            },
            withCredentials: false,
            mode: 'no-cors',
            url: `${END_POINT_APPROVE_REQUISITIONS}${item._id}`,
            data: {status}
        }
    ).then( response => {

        if(response.status === INSERT_SUCCESS){
            
            axios(
                {
                    method: 'get',
                    headers: {
                    'Content-Type': 'application/json',
                    'Authorization': sessionStorage.getItem(JWT), 
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache'
                    },
                    withCredentials: false,
                    mode: 'no-cors',
                    url: END_POINT_GET_REQUISITIONS,
                    params: { page: page_index, sort: "-_created"}
                }
            ).then( response => {
        
                if(response.status === GET_SUCCESS){
                    window.alert("Update Success")
                    dispatch({
                        type: REQUISITION_LIST,
                        payload: response.data._items
                    })
                }else{
                    window.alert("RESPONSE ERROR!")
                }
        
            }).catch( error => {
        
                if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
                    dispatch({
                        type: UNAUTHORIZE,
                        payload: true
                    })
                }else{

                    window.alert(error)
                }
                
        
            })

        }else {
            window.alert("Updated Failed")
        }

    }).catch( error => {
        
        if( error.response !== undefined){

            if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
                dispatch({
                    type: UNAUTHORIZE,
                    payload: true
                })
            }else{
                window.alert("NETWORK OR SERVER ERROR!")
            }
        }else{

            window.alert("SERVER ERROR!")

        }
        
    })

}

export const getRequisitionDetail = (prop) => dispatch => {

    axios(
        {
            method: 'get',
            headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': true,
            // 'Authorization': sessionStorage.getItem(JWT) === null ? prop.jwt : sessionStorage.getItem(JWT), 
            },
            withCredentials: false,
            mode: 'no-cors',
            url: `${END_POINT_GET_REQUISITIONS}/${prop.id}`,
        }
    ).then( response => {

        if(response.status === GET_SUCCESS) {
            dispatch({
                type: REQUISITION_ITEM,
                payload: response.data
            })
        }else{
            window.alert(response.statusText)
        }

    }).catch( error => {

        if(error.response.status === RESPONSE_CODE_UNAUTHORIZED) {
            window.alert("Session Expire! Pelase login again")
            dispatch({
                type: UNAUTHORIZE,
                payload: true
            })
        }else{
            window.alert(error)
        }

    })

}

export const onChangeAdditionalRequirement = (data) => dispatch => {
    const htmlValue = stateToHTML(data)

    dispatch({
        type: ADDITIONAL_REQUIRMENT,
        payload: htmlValue
    })

}

export const onChangeLocalBenefit = (data) => dispatch => {

    dispatch({
        type: LOCAL_BENEFIT,
        payload: data
    })

}

export const onChangeJobRequirment = (text) => dispatch => {

    const htmlValue = stateToHTML(text)
    dispatch({
        type: JOB_REQUIRMENT,
        payload: htmlValue
    })
}

export const onChangeJobDescription = (text) => dispatch => {

    const htmlValue = stateToHTML(text)
     dispatch({
         type: JOB_DESCRIPTION,
         payload: htmlValue
     })
}

export const loadBenefit = (prop) => dispatch => {
    dispatch({
        type: LOAD_BENEFIT,
        payload: prop
    })
}